<template>
  <a-modal
    :title="title"
    :width="modalWidth"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('antd.table.close')"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('pwd.oldPassword')">
          <a-input type="password" :placeholder="$t('pwd.oldPwdMsg')" v-decorator="[ 'oldPassword', validatorRules.oldPassword]" />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('pwd.newPassword')">
          <a-input type="password" :placeholder="$t('pwd.newPwdMsg')" v-decorator="[ 'password', validatorRules.password]" />
        </a-form-item>
        
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('pwd.confirmPassword')">
          <a-input type="password" @blur="handleConfirmBlur" :placeholder="$t('pwd.confirmPwdMsg')" v-decorator="[ 'confirmpassword', validatorRules.confirmpassword]"/>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { userUpdatePassword } from '@/api/app'

  export default {
    name: "UserPassword",
    data () {
      return {
        title: this.$t('pwd.changePwd'),
        modalWidth:800,
        visible: false,
        confirmLoading: false,
        validatorRules:{
          oldPassword:{
            rules: [{
              required: true, message: this.$t('pwd.oldPwdMsg'),
            }],
          },
          password:{
            rules: [{
              required: true, message: this.$t('pwd.newPwdMsg'),
            }, {
              validator: this.validateToNextPassword,
            }],
          },
          confirmpassword:{
            rules: [{
              required: true, message: this.$t('pwd.confirmPwdMsg'),
            }, {
              validator: this.compareToFirstPassword,
            }],
          }
        },
        confirmDirty:false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        form:this.$form.createForm(this),
        userId:"",
      }
    },
    methods: {
      show(uname){
        if(!uname){
          this.$message.warning(this.$t('pwd.noLogin'));
          return
        }else{
          this.userId = uname
          this.form.resetFields();
          this.visible = true;
        }
      },
      handleCancel () {
        this.close()
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
        this.selectedRole = [];
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let params = Object.assign({
              id:this.userId,
              oldPassword:window.btoa(values.oldPassword),
              password:window.btoa(values.confirmpassword)
            })
            console.log("修改密码提交数据",params)
            userUpdatePassword(params).then((res)=>{
              if(res.code == '200'){
                console.log(res)
                that.$message.success(res.msg);
                that.close();
              }else{
                that.$message.warning(res.msg);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      validateToNextPassword  (rule, value, callback) {
        const form = this.form;
        if (value && this.confirmDirty) {
          form.validateFields(['confirm'], { force: true })
        }
        callback();
      },
      compareToFirstPassword  (rule, value, callback) {
        const form = this.form;
        if (value && value !== form.getFieldValue('password')) {
          callback(this.$t('pwd.noinset'));
        } else {
          callback()
        }
      },
      handleConfirmBlur  (e) {
        const value = e.target.value
        this.confirmDirty = this.confirmDirty || !!value
      }

    }
  }
</script>

<style scoped>

</style>

